export default __webpack_public_path__ + "static/media/Raider's Hood of World's Edge.cf415221.jpg";